<template>
  <div class="souzai-components">
    <MyModal @close="closeModal" v-if="modal">
      <!-- default スロットコンテンツ -->
      <div class="iframe-wrapper">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/cqI6vDFX-dc" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <!-- /default -->
    </MyModal>
    <div class="souzai">
      <div class="head-wrapper">
        <div class="jumbotron">
          <img src="../../assets/img/job/souzai/jumbotron.jpg" alt="" class="over_display">
          <img src="../../assets/img/job/souzai/jumbotron_under.jpg" alt="" class="under_display">
        
        </div>
        <div class="message-tile">
          <div class="message-tile-inner">
            <div class="message">
              <img src="../../assets/img/job/souzai/catch.png" alt="1日の半分以上は、黒子として集中する。接客は少なめです。" width="390px">
            </div>
            <div class="movie-button" @click="openModal">
              <img src="../../assets/img/job/movie_button.png" alt="1分で仕事を見る" width="360px">
            </div>
          </div>
        </div>
      </div>
      <div class="main-contents">
        <div class="type-section">
          <FukidashiTitle title="どんなタイプの先輩がいる？" />
          <TypeAnswer genre="souzai" message="自分のリズムで<br class='under_display'>コツコツ集中したい、<br>気負わず働きたい人。"/>
        </div>
        <div class="type-section">
          <FukidashiTitle title="1日でお客様と接する時間は？" />
          <Graph graphNumber="40" />
          <div class="details">
            <p>
            惣菜部は、「自ら調理した商品を提供する」スーパーでは唯一の部門。1日の半分以上をキッチンで過ごします。お客様と会話する機会はかなり少ないです。常連さんと「今日はいい天気ですね」と挨拶したり、たまに産地や味付けの質問を受けたりする程度です。
            </p>
            <p>
            ユニークな仕事としてご紹介したいのは、「食べること」。自分がおいしい！と思った商品は、自信をもって売場に並べます。体重が増えないよう、それだけは注意しています。
            </p>
            <p>
            早くから売場づくりを経験できるのも、惣菜部の特徴です。今日はこれを推したい、と自らお弁当や揚げ物をつくってディスプレイを仕掛けられる。自分の個性を活かしたい方、自分のリズムでコツコツやりたい方に向いていると思います。それから、帽子とマスク着用なので、お化粧は目の周りだけでいい。そんな気軽な感じも、私は好きです。
            </p>
            </div>
        </div>
        <ScheduleLink />
      </div>
    </div>
  </div>
</template>

<script>
import MyModal from '@/components/MyModal.vue'
import FukidashiTitle from '@/components/job/FukidashiTitle.vue'
import TypeAnswer from '@/components/job/TypeAnswer.vue'
import Graph from '@/components/job/Graph.vue'
import ScheduleLink from '@/components/job/ScheduleLink.vue'
export default {
  name: 'Souzai',
  components: {
    MyModal,
    FukidashiTitle,
    TypeAnswer,
    Graph,
    ScheduleLink
  },
  data() {
    return {
      modal: false,
    }
  },
  methods: {
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false
    },
  }
}
</script>
<style scoped lang="scss">
.iframe-wrapper{
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 56%;
  iframe{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.souzai {
  padding-bottom: 100px;
  margin: 0 auto;
  &:before {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    left: 0;
    top: 800px;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
  &:after {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    right: 0;
    top: 0;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
}
.head-wrapper {
  position: relative;
}
.jumbotron {
  margin: 0 auto;
  max-width: 1300px;
  width: 100%;
}
.message-tile {
  position: absolute;
  display: flex;
  top: 0;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  transform: translateX(-40px);
  max-width: 1300px;
  width: 100%;
  left: 0;
  margin: auto;
  right: 0;
  @media print, screen and (max-width: 960px) {
    width: 50%;
    right: 0;
    left: unset;
    transform: translateX(-5px);
  }
}
.message-tile-inner {
  position: relative;
}
.movie-button {
  position: absolute;
  bottom: 30px;
  right: -30px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  @media print, screen and (max-width: 960px) {
    right: -5px;
  }
  &:hover {
    opacity: 0.5;
  }
  img {
    vertical-align: middle;
  }
}
.main-contents {
  margin: 0 auto;
  margin-top: 100px;
  max-width: 750px;
  width: 100%;
  @media print, screen and (max-width: 750px) {
    width: 90%;
  }
}
.type-section + .type-section {
  margin-top: 100px;
}
.details {
  font-size: 12px;
  line-height: 2em;
  margin-top: 50px;
}
</style>
